import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Services = () => {
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);

  // --- PROFESSIONAL COLOR PALETTE ---
  const premiumWoodColor = "#b84213"; // Rich wood/accent color (Matches your brand)
  const darkSlateColor = "#221f1d";   // Elegant dark charcoal for frames & hardware
  const midWoodColor = "#965b32";     // For plywood layering
  const lightWoodColor = "#c98f5f";   // For plywood layering

  // All 4 Categories guaranteed to be here
  const categories = [
    {
      title: 'DOORS',
      description: 'Premium wooden & safety doors',
      path: '/doors',
      available: true,
      icon: (
        <svg viewBox="0 0 24 24" className="animated-icon door-icon">
          {/* Professional Dark Frame */}
          <path className="door-frame" d="M3 3h18v18H3z" fill="none" stroke={darkSlateColor} strokeWidth="1.5" />
          {/* Premium Wood Color Door Leaf */}
          <rect className="door-leaf" x="5" y="4" width="14" height="16" fill={premiumWoodColor} />
          {/* Crisp White/Silver Knob */}
          <circle className="door-knob" cx="16" cy="12" r="1.2" fill="#ffffff" />
        </svg>
      ),
      delay: 0,
    },
    {
      title: 'HARDWARE',
      description: 'Luxury handles & fittings',
      path: null,
      available: false,
      icon: (
        <svg viewBox="0 0 24 24" className="animated-icon handle-icon">
          {/* Dark Backplate */}
          <rect x="9" y="4" width="4" height="16" rx="1" fill={darkSlateColor} opacity="0.9" />
          <g className="handle-lever-group">
            {/* Lever Pivot */}
            <circle cx="11" cy="10" r="1.8" fill={darkSlateColor} />
            {/* Premium Gold/Wood Colored Lever */}
            <path d="M11 8.5c3 0 8-0.5 8 1.5s-1 2.5-4 2.5h-4" fill={premiumWoodColor} />
          </g>
        </svg>
      ),
      delay: 200,
    },
    {
      title: 'PLYWOOD & LAMINATES',
      description: 'High-grade finishing materials',
      path: null,
      available: false,
      icon: (
        <svg viewBox="0 0 24 24" className="animated-icon ply-icon">
          <path d="M3 5h14v4H3z" fill={lightWoodColor} />
          <path d="M5 9h14v4H5z" fill={midWoodColor} />
          <path d="M7 13h14v4H7z" fill={premiumWoodColor} />
        </svg>
      ),
      delay: 100,
    },
    {
      title: 'CUSTOM DESIGNS',
      description: 'Tailored interior solutions',
      path: null,
      available: false,
      icon: (
        <svg viewBox="0 0 24 24" className="animated-icon design-icon">
          {/* Dark Slate Ruler Base */}
          <path d="M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z" fill={darkSlateColor} />
          {/* Premium Colored Pencil Detail */}
          <path className="pencil" d="M12 7l-2 2 4 4L16 9z" fill={premiumWoodColor} />
        </svg>
      ),
      delay: 300,
    },
  ];

  const handleCardClick = (path) => {
    if (path) {
      navigate(path);
    } else {
      setShowPopup(true);
    }
  };

  return (
    <div>
      <style>
        {`
        @import url('https://fonts.googleapis.com/css2?family=Oswald:wght@500;600&family=Inter:wght@400;700&display=swap');

        /* =========================
           COMING SOON CARDS
        ========================= */
        .coming-soon-card {
          position: relative;
          opacity: 0.78;
        }

        .coming-soon-card::before {
          content: "";
          position: absolute;
          inset: 0;
          background: rgba(255,255,255,0.12);
          pointer-events: none;
          z-index: 1;
        }

        .coming-soon-card .category-icon-box,
        .coming-soon-card .category-text,
        .coming-soon-card .category-link {
          position: relative;
          z-index: 2;
        }

        .coming-soon-card .animated-icon {
          filter: grayscale(40%);
        }

        .coming-soon-card:hover {
          opacity: 1;
        }

        .coming-badge {
          position: absolute;
          top: 10px;
          right: 10px;
          z-index: 10;
          background: rgba(184,66,19,0.1);
          border: 1px solid rgba(184,66,19,0.2);
          color: #b84213;
          padding: 4px 10px;
          border-radius: 30px;
          font-size: 0.65rem;
          font-weight: 700;
          letter-spacing: 0.5px;
          text-transform: uppercase;
        }

        .category-section {
          background: #fdfdfb;
          padding: 80px 0;
          font-family: 'Inter', sans-serif;
          overflow-x: hidden;
        }

        .section-title,
        .section-title span {
          font-family: 'Oswald', sans-serif;
        }

        .section-title {
          font-size: 2.5rem;
          font-weight: 500;
          text-align: center;
          margin-bottom: 8px;
          color: #221f1d;
          letter-spacing: 2px;
          text-transform: uppercase;
        }

        .section-title span {
          color: #fc7303;
          position: relative;
        }

        .section-subtitle {
          text-align: center;
          font-size: 0.85rem;
          color: #777;
          margin-bottom: 45px;
          letter-spacing: 1.5px;
          text-transform: uppercase;
          font-weight: 500;
        }

        .category-card {
          background: #ffffff;
          border: 1px solid #eee;
          padding: 22px 14px;
          text-align: center;
          transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
          cursor: pointer;
          height: 100%;
          border-radius: 8px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;
        }

        .category-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 15px 35px rgba(184, 66, 19, 0.1);
          border-color: #b84213;
        }

        .category-icon-box {
          width: 55px;
          height: 55px;
          margin: 0 auto 15px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .animated-icon {
          width: 42px;
          height: 42px;
          transition: all 0.3s ease;
        }

        /* ANIMATIONS */
        .door-leaf { transform-origin: left; transition: transform 0.6s ease; }
        .category-card:hover .door-leaf { transform: perspective(1200px) rotateY(-50deg); }

        .handle-lever-group { transform-origin: 11px 10px; transition: transform 0.4s ease; }
        .category-card:hover .handle-lever-group { transform: rotate(20deg); }

        .ply-icon path { transition: transform 0.4s ease; }
        .category-card:hover .ply-icon path:nth-child(1) { transform: translate(-4px, -4px); }
        .category-card:hover .ply-icon path:nth-child(2) { transform: translate(0, 0); }
        .category-card:hover .ply-icon path:nth-child(3) { transform: translate(4px, 4px); }

        .pencil { transition: transform 0.5s ease; }
        .category-card:hover .pencil { transform: translate(2px, 2px) scale(1.15); }

        .category-text h5 {
          font-family: 'Oswald', sans-serif;
          font-weight: 600;
          font-size: 0.95rem;
          margin: 0 0 6px 0;
          color: #221f1d;
          letter-spacing: 1px;
        }

        .category-text p {
          font-size: 0.72rem;
          color: #777;
          line-height: 1.3;
          margin: 0;
        }

        .category-link {
          margin-top: 12px;
          display: inline-block;
          font-size: 0.65rem;
          font-weight: 800;
          letter-spacing: 1.5px;
          text-transform: uppercase;
          color: #b84213;
          opacity: 0;
          transition: opacity 0.3s ease, transform 0.3s ease;
          transform: translateY(5px);
        }

        .category-card:hover .category-link {
          opacity: 1;
          transform: translateY(0);
        }

        /* POPUP STYLES */
        .popup-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          background: rgba(0, 0, 0, 0.7);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
          opacity: 0;
          animation: fadeIn 0.3s forwards;
        }

        .popup-content {
          background: #fff;
          padding: 40px;
          border-radius: 8px;
          text-align: center;
          max-width: 400px;
          width: 90%;
          box-shadow: 0 15px 30px rgba(0,0,0,0.2);
          transform: translateY(20px);
          animation: slideUp 0.3s forwards;
          font-family: 'Inter', sans-serif;
          border-top: 4px solid #b84213;
        }

        .popup-content h3 {
          font-family: 'Oswald', sans-serif;
          color: #221f1d;
          margin-bottom: 15px;
          letter-spacing: 1px;
        }

        .popup-content p { color: #555; font-size: 0.95rem; margin-bottom: 25px; }
        .close-btn {
          background: #b84213; color: #fff; border: none; padding: 10px 25px;
          font-family: 'Oswald', sans-serif; letter-spacing: 1px; border-radius: 4px;
          cursor: pointer; transition: background 0.3s ease;
        }
        .close-btn:hover { background: #221f1d; }

        @keyframes fadeIn { to { opacity: 1; } }
        @keyframes slideUp { to { transform: translateY(0); } }

        /* ===== MOBILE RESPONSIVE TWEAKS FOR 2x2 GRID ===== */
        @media (max-width: 768px) {
          .category-section {
            padding: 30px 0;
          }

          .coming-badge {
            display: none !important;
          }

          .section-title {
            font-size: 2rem;
            margin-bottom: 6px;
          }

          .section-subtitle {
            font-size: 0.72rem;
            margin-bottom: 24px;
          }

          .row.g-3 {
            --bs-gutter-x: 0.55rem;
            --bs-gutter-y: 0.55rem;
          }

          .category-card {
            padding: 14px 10px;
            min-height: 175px;
            max-height: 175px;
            border-radius: 6px;
          }

          .category-icon-box {
            margin-bottom: 12px;
          }

          .category-link {
            margin-top: 10px;
            opacity: 1;
            transform: translateY(0);
          }
        }

        @media (max-width: 480px) {
          .row.g-3 {
            --bs-gutter-x: 0.45rem;
            --bs-gutter-y: 0.45rem;
          }

          .category-card {
            padding: 12px 8px;
            min-height: 165px;
            max-height: 165px;
          }

          .category-icon-box {
            margin-bottom: 10px;
          }

          .animated-icon {
            width: 26px;
            height: 26px;
          }

          .category-text h5 {
            font-size: 0.88rem;
          }

          .category-text p {
            font-size: 0.75rem;
          }

          .category-link {
            font-size: 0.65rem;
            margin-top: 8px;
          }
        }
        `}
      </style>

      <section className="category-section pt-4">
        <div className="container">
          <h1 className="section-title">
            Our <span>Products</span>
          </h1>
          <p className="section-subtitle">
            Doors, Plywood &amp; Hardware in Rajamahendravaram (Rajahmundry)
          </p>
          <div className="row g-3">
            {categories.map((cat, idx) => (
              <div
                className="col-lg-3 col-md-3 col-6"
                key={idx}
                data-aos="fade-up"
                data-aos-delay={cat.delay}
              >
                <div
                  className={`category-card ${cat.available
                    ? "active-card"
                    : "coming-soon-card"
                    }`}
                  onClick={() => handleCardClick(cat.path)}
                >
                  {!cat.available && (
                    <span className="coming-badge">
                      Coming Soon
                    </span>
                  )}
                  <div className="category-icon-box">
                    {cat.icon}
                  </div>
                  <div className="category-text">
                    <h5>{cat.title}</h5>
                    <p>{cat.description}</p>
                  </div>
                  <span className="category-link">
                    {cat.available ? "Explore →" : "Coming Soon"}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* COMING SOON POPUP MODAL */}
      {showPopup && (
        <div className="popup-overlay" onClick={() => setShowPopup(false)}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <h3>Coming Soon!</h3>
            <p>We are working hard to bring this service online. Stay tuned for updates!</p>
            <button className="close-btn" onClick={() => setShowPopup(false)}>
              CLOSE
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Services;
